/* global $:false */

import PusherClient from 'src/shared/pusher_client.js'

export default class WatchingLiveChanges {
  static init () {
    this.ifLive = $('[data-reload-if-live]').length > 0
    this.ifDead = $('[data-reload-if-dead]').length > 0
    this.ifLivePublic = $('[data-reload-if-live-for-public]').length > 0
    this.ifDeadPublic = $('[data-reload-if-dead-for-public]').length > 0
    if (!this.ifLive &&
        !this.ifDead &&
        !this.ifLivePublic &&
        !this.ifDeadPublic) { return }
    this.subscribeToLiveChannelUpdates()
    return this.update()
  }

  static subscribeToLiveChannelUpdates () {
    const pusher = PusherClient.connection()
    const liveInterfaceChannel = pusher.subscribe('live-interface')

    return liveInterfaceChannel.bind('ongoing', data => this.update())
  }

  static update () {
    this.updatePreview()
    return this.updatePublic()
  }

  static updatePreview () {
    if (!this.ifLive && !this.ifDead) { return }
    const checkPath = window.gon && window.gon.live_ongoing_check_path
    if (!checkPath) { return }

    return $.ajax(checkPath, {
      success: (data, status, request) => {
        switch (request.status) {
          case 204: if (this.ifDead) { return this.reload() } break
          case 200: if (this.ifLive) { return this.reload() } break
        }
      }
    }
    )
  }

  static updatePublic () {
    if (!this.ifLivePublic && !this.ifDeadPublic) { return }
    const checkPath = window.gon && window.gon.live_ongoing_for_public_check_path
    if (!checkPath) { return }

    return $.ajax(checkPath, {
      success: (data, status, request) => {
        switch (request.status) {
          case 204: if (this.ifDeadPublic) { return this.reload() } break
          case 200: if (this.ifLivePublic) { return this.reload() } break
        }
      }
    }
    )
  }

  static reload () {
    window.location.reload()
  }
}
